import React from 'react'
import PropTypes from 'prop-types'
import { useCheckPolicy } from '../../../../../../hooks'
import ArchiveReportModal from './ArchiveReportModal'
import SummaryReportModal from './SummaryReportModal'
import RunNewReportModal from './RunNewReportModal'
import CreateWealthJourneyEntryModal from './CreateWealthJourneyEntryModal'

function StatusReportModal ({
  statusReportId,
  statusTemplateId,
  levelId,
  mode,
  onClose
}) {
  const canEditStatusReport = useCheckPolicy('status_report_edit')

  if (!mode || !canEditStatusReport) return null

  if (mode === 'archive') {
    return (
      <ArchiveReportModal
        open={!!statusReportId}
        onClose={onClose}
        statusReportId={statusReportId}
      />
    )
  }

  if (mode === 'summary') {
    return (
      <SummaryReportModal
        open={!!statusReportId}
        onClose={onClose}
        statusReportId={statusReportId}
      />
    )
  }

  if (mode === 'run-new') {
    return (
      <RunNewReportModal
        open
        onClose={onClose}
        statusTemplateId={statusTemplateId}
        levelId={levelId}
      />
    )
  }

  if (mode === 'wealth-journey-entry') {
    return (
      <CreateWealthJourneyEntryModal
        open={!!statusReportId}
        onClose={onClose}
        statusReportId={statusReportId}
      />
    )
  }

  return null
}

StatusReportModal.propTypes = {
  statusReportId: PropTypes.number,
  statusTemplateId: PropTypes.number,
  levelId: PropTypes.number,
  mode: PropTypes.oneOf(['archive', 'summary', 'run-new', 'wealth-journey-entry']),
  onClose: PropTypes.func.isRequired
}

export default StatusReportModal
